import { render } from "./Terminbuchung.vue?vue&type=template&id=59bad57d"
import script from "./Terminbuchung.vue?vue&type=script&lang=js"
export * from "./Terminbuchung.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__